/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> | boolean {
    return this.checkLogin(state.url, route);
  }
  // CheckLogin
  checkLogin(url: string, route: any): Promise<boolean> | boolean {
    let lastPath: any;
    if (route.url && route.url.length > 0 && route.url[0].path) {
      lastPath = route.url[0].path;
    }
    let currentUser: any;
    currentUser = sessionStorage.getItem('vendorToken');


    if (currentUser) {
      if (url === '/auth/login' || url === '/auth' || url === '/auth/recover-password' || lastPath === 'set-password') {
        // Navigate to the login page with extras
        this.router.navigate(['/products']);
        return false;
      }
      return true;
    } else {
      if (url === '/auth/login' || url === '/auth' || url === '/auth/recover-password' || lastPath === 'set-password') {
        return true;
      } else {
        this.router.navigate(['/auth/login']);
      }
    }
    // Navigate to the login page with extras
    this.router.navigate(['/auth/login']);
    return false;
  }
}
